const baseURL = window.__RUNTIME_CONFIG__.REACT_APP_BASE_API_URL || 'http://localhost:8080/v1';
const exportURL = baseURL; 	

export default { baseURL, exportURL };